import { useCallback } from 'react';

import { useTheme } from '@/common/ThemeContext';
import { UnifiedIcon } from '@/components/UnifiedIcon';

/**
 * Toggle between light and dark theme (sets `dark` class on `<html>`).
 */
export function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  const handleToggle = useCallback(() => {
    toggleTheme();
  }, [toggleTheme]);

  return (
    <button
      type="button"
      data-testid="agents-theme-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDark}
      onClick={handleToggle}
      className="rounded-lg p-2 text-secondary transition-colors hover:bg-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--kc-focus-ring)]"
    >
      <UnifiedIcon name={isDark ? 'Sun' : 'Moon'} size={20} className="h-5 w-5" />
    </button>
  );
}
